import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material';

@Component({
  selector: 'app-notification-message',
  templateUrl: './notification-message.component.html',
  styleUrls: ['./notification-message.component.css']
})
export class NotificationMessageComponent implements OnInit {

  constructor(   public snackBarRef: MatSnackBarRef<NotificationMessageComponent>,
                 @Inject(MAT_SNACK_BAR_DATA) public data: any ) { 
    
    }

  ngOnInit() {
  }


 
}
